<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            Registrar Alergia
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="4" md="6">
              <v-text-field
                v-model="alergia"
                prepend-icon="mdi-account"
                label="Alergia *"
                maxlength="100"
                :rules="requiredRules"
                dense
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="6">
              <v-text-field
                v-model="observaciones"
                prepend-icon="mdi-account"
                label="Observaciones"
                maxlength="200"
                dense
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" :disabled="!valid" @click.stop="guardarAlergia"
            >Guardar</v-btn
          >

          <v-btn color="error" @click.stop="show = false">Salir</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import axios from "../../axios-auth.js";

export default {
  data: (vm) => ({
    alergia: "",
    observaciones: "",
    lazy: false,
    valid: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
  }),

  props: ["visible", "idPaciente"],

  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    guardarAlergia() {
      this.$swal({
        title: "Registrar Alergia",
        text: "¿Desea registrar la alergia?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const datosAlergia = {
            alergia: this.alergia,
            observaciones: this.observaciones,
            idPaciente: this.idPaciente,
          };
          let self = this;
          axios
            .post("/Paciente/GuardarAlergia", datosAlergia)
            .then((response) => {
              if (response.data == "error") {
                self.showAlert({
                  icon: "error",
                  title: "Ya existe una alergia registrada con ese nombre",
                  vm: self,
                });
              } else {
                self.$refs.form.resetValidation();
                self.vaciarModels();

                document.getElementsByClassName(
                  "v-dialog--active"
                )[0].scrollTop = 0;
                self.showAlert({
                  icon: "success",
                  title: "Alergia registrada exitosamente",
                  vm: self,
                });
                self.$emit("alergiaRegistrada");
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "La alergia no pudo ser registrada",
                vm: this,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },

    vaciarModels() {
      this.alergia = "";
      this.observaciones = "";
    },

    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 2000,
      });
    },
  },

  created() {
    this.vaciarModels();
  },
};
</script>
